import { render, staticRenderFns } from "./formularios.vue?vue&type=template&id=2094f8bb"
import script from "./formularios.vue?vue&type=script&lang=ts"
export * from "./formularios.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports